import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse, ILead } from "../models/Lead";

// Mirrors the API's SubmitCodResponse. On success `message` is only populated when DVLA
// returned a warning alongside the certificate (e.g. the account password is expiring).
export interface ICodResponse {
  success: boolean;
  message: string | null;
  certificateNumber: string | null;
  certificateString: string | null;
}

export default function useCod() {
  const { post } = useApiHelper();
  const queryClient = useQueryClient();

  const runCod = useMutation(
    (leadId: any) => post<null, ICodResponse>(`/lead/${leadId}/cod`, null),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["leads"]);
        queryClient.invalidateQueries(["vehicles"]);
      },
    }
  );


  return {
    runCod,
  };
}
